import { createBrowserHistory } from 'history';
import { VIRTUAL_DIRECTORY } from '../constants/appConstant';

export default createBrowserHistory({
  basename: VIRTUAL_DIRECTORY,
});
